import { gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query fetchCollectionOffers($collectionId: String!, $limit: Int!) {
    Offers(where: { collections: { equals: $collectionId } }, limit: $limit) {
      docs {
        id
        name
        slug
        description
        brand {
          id
          slug
        }
        featuredImage {
          id
          url
          alt
        }
      }
    }
  }
`

export interface CollectionOffersQueryInput {
  collectionId: string
  limit: number
}

export interface CollectionOffersQueryOutput {
  Offers: {
    docs: {
      id: string
      name: string
      slug: string
      description: string
      brand: {
        id: string
        slug: string
      }
      featuredImage: {
        id: string
        url: string
        alt: string
      }
    }[]
  }
}

export const useCollectionOffersQuery = (input: CollectionOffersQueryInput) =>
  usePersistedCacheQuery<CollectionOffersQueryOutput, CollectionOffersQueryInput>(query, {
    variables: input,
  })
